import React, { useState } from "react";
import AvatarSelection from "../../components/AvatarSelection/AvatarSelection";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import cat from "../../images/avatars/cat.png";
import "./TestPage.css";
const TestPage1 = (props) => {
  const [popup, setPopup] = useState(false);
  const [authError, setAuthError] = useState(false);
  const [handle, setHandle] = useLocalStorage("ambientHandle", "ambientUser");
  const [avatar, setAvatar] = useLocalStorage("ambientAvatar", cat);

  const [formData, setFormData] = useState({
    handle: "",
      avatar: cat,

  });
  console.log({ formData });
  const handlePopup = () => {
    setPopup(!popup);
  };

  const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
     
  

      console.log({...formData})

    setHandle(formData.handle);
    setAvatar(formData.avatar);
  };

  // const handleSubmit = async (e) => {
  // console.log("clicked")
  // }

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("submitting");

    console.log({ formData });
  };
  return (
    <div className="signup-page">
      {popup && (
        <AvatarSelection
          formData={formData}
          handleChange={handleChange}
          handlePopup={handlePopup}
        />
      )}

      <div className="left-container">
        <div className="form-container">
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <h1>{handle}</h1>
              <img src={avatar} alt="avatar" width="30px" />
            </div>
          <div className="title-container">
            <h1>Update your profile</h1>
          </div>
          <form className="register-form" onSubmit={handleSubmit}>
            <input
              onChange={handleChange}
              value={formData.handle}
              autoComplete="off"
              required
              name="handle"
              type="text"
              placeholder={handle ? handle : "Username"}
            />

            <button id="avatar-button" type="button" onClick={handlePopup}>
              {avatar && avatar !== cat ? (
                <img src={avatar} alt="your avatar" width="30px" />
              ) : (
                "Select Avatar"
              )}
            </button>

            <button id="submit-button" onClick={handleSubmit}>
              Finish Profile
            </button>
          </form>
        </div>
      </div>

      <div className="right-container">
        <div className="lottie"></div>
      </div>
    </div>
  );
};

export default TestPage1;
